<div *ngIf="show" @state [ngClass]="['toast-wrapper', type]">
  <div class="toast-message-container">
    <!-- icon placeholders till we get an icon library -->
    <span class="toast-header">
      <span class="icon" *ngIf="type === 'success'">&#x2714;</span>
      <span class="icon" *ngIf="type === 'error'">&#x2715;</span>
      <span class="icon" *ngIf="type === 'info'">&#x24D8;</span>
      <span class="icon" *ngIf="type === 'warning'">&#x26A0;</span>
      <span>{{ type | titlecase }}!</span>
    </span>
    <!--whitespace: pre, allows new line characters.-->
    <span class="toast-message">
      {{ message }}
    </span>
    <span class="toast-details" *ngIf="details">
      <hr />
      {{ details }}
    </span>
    <button (click)="closeToast()" class="close-toast">X</button>
  </div>
</div>
